export enum NodeType {
  Root = 0,
  Site = 1,
  Building = 2,
  MediaPlayer = 3,
}
